<template>
  <div style="height: 100%">
    <v-card>
      <v-card-title>Account Tasks ({{ allTasks.length }})</v-card-title>
      <v-card-text>
        <v-simple-table dense>
          <template v-slot:default>
            <thead>
              <tr>
                <th>Tagged</th>
                <th>Details</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="!limitedTasks || limitedTasks.length === 0">
                <td colspan="3">No tasks to complete</td>
              </tr>
              <tr v-for="task in limitedTasks" :key="task.id">
                <td>{{ task.tagged }}</td>
                <td>{{ task.details.length > 30 ? task.details.substr(0, 30) + '...' : task.details }}</td>
                <td>
                  <v-icon v-if="task.link" :disabled="isOnLink(task.link)" @click="goToTask(task.link)">mdi-link</v-icon>
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn text @click="showTasksDialog = true">Show All Tasks</v-btn>
      </v-card-actions>
    </v-card>
    <user-tasks-dialog :dialog.sync="showTasksDialog" :show-only-user="false" />
  </div>
</template>

<script>
import UserTasksDialog from '@/components/tasks/UserTasksDialog.vue'
import { mapGetters } from 'vuex'

const numberOfTasksToShow = 3
export default {
  components: { UserTasksDialog },

  data: () => ({
    showTasksDialog: false,
  }),
  methods: {
    goToTask(link) {
      const previousRoute = this.$router.currentRoute.fullPath
      this.$router.push(link)
      if (previousRoute.includes('/schedules/') && link.includes('schedules')) {
        location.reload()
      }
    },
    isOnLink(link) {
      return this.$route.fullPath === link
    },
  },
  computed: {
    ...mapGetters({
      getAccountTasks: 'getAccountTasks',
    }),
    limitedTasks() {
      if (this.allTasks.length <= numberOfTasksToShow) return this.allTasks
      return this.allTasks.slice(0, numberOfTasksToShow)
    },
    allTasks() {
      if (this.getAccountTasks) {
        return this.getAccountTasks.all || []
      }
      return []
    },
  },
}
</script>
<style scoped lang="scss">
.v-card {
  height: 100%;
}

.v-card__text,
.v-card__title {
  word-break: normal; /* maybe !important  */
}

.v-card__text {
  padding-bottom: 3rem;
}
.no-events-text {
  color: rgb(0,0,0,0.5);
}
.v-card__actions {
  position: absolute;
  bottom: 0;
  width: 100%;

}
</style>